import templateToJsx from "@lib/templateToJsx";

const CredexUserPromoBannerDefaultLabel = ({ firstName, credexConfig }) => (
  <div className="flex flex-col">
    {firstName && credexConfig.bannerTitle && (
      <div className="text-[14px] font-medium">
        {templateToJsx(credexConfig.bannerTitle, { firstName })}
      </div>
    )}

    {credexConfig.bannerSubTitle && (
      <div className="text-[12px]">{credexConfig.bannerSubTitle}</div>
    )}
  </div>
);
export default CredexUserPromoBannerDefaultLabel;
